import React from 'react';
import { useHits } from 'react-instantsearch';
import { SequenceCard } from '@/components/sequences/SequenceCard';
import { Sequence } from '@/types/sequence';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { SequenceTransformService, TypesenseHit } from '@/lib/search/SequenceTransformService';

interface HitsProps {
  onClearFilters?: () => void;
}

export const Hits: React.FC<HitsProps> = ({ onClearFilters }) => {
  const { hits } = useHits();

  // Transform Typesense hits to Sequence objects using centralized service
  const sequences: Sequence[] = SequenceTransformService.transformHitsToSequences(hits as TypesenseHit[]);

  if (sequences.length === 0) {
    return (
      <Card className="text-center py-12">
        <CardContent>
          <h3 className="text-lg font-semibold mb-2">No sequences found</h3>
          <p className="text-muted-foreground mb-4">
            Try adjusting your search terms or filters
          </p>
          {onClearFilters && (
            <Button onClick={onClearFilters}>Clear all filters</Button>
          )}
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {sequences.map((sequence) => (
        <SequenceCard key={sequence.id} sequence={sequence} />
      ))}
    </div>
  );
};